import { asyncAction, syncAction } from 'lib/action';

export const fetchChatUsers = asyncAction('CHAT/GET_CHATUSERS');
export const fetchCompanyChatUsers = asyncAction('CHAT/GET_COMPANY_CHATUSERS');
export const fetchDocumentChatUsers = asyncAction('CHAT/GET_DOCUMENT_CHATUSERS');

export const setActiveChannelAction = syncAction('CHAT/SET_ACTIVE_CHANNEL', ({ threadId, companyId }) => ({
  payload: { name: threadId, companyId },
}));

// same as setActiveChannelAction but its result will not be cleaned by chat component unmount
export const setActiveChannelForceAction = syncAction('CHAT/SET_ACTIVE_CHANNEL_FORCE', ({ threadId, companyId }) => ({
  payload: { name: threadId, companyId },
}));
export const removeActiveChannelForceAction = syncAction('CHAT/REMOVE_ACTIVE_CHANNEL_FORCE');

export const chatReadyToRenderAction = syncAction('CHAT/READY_TO_RENDER');
export const setOpenAction = syncAction('CHAT/SET_OPEN');
export const onInitOneSignalAction = syncAction('CHAT/ON_INIT_ONE_SIGNAL');
export const chatResetUsersAction = syncAction('CHAT/RESET_USERS');

export const setChannelUrlAction = syncAction('CHAT/SET_CHANNEL_URL');
export const setTargetMessageAction = syncAction('CHAT/SET_TARGET_MESSAGE');
export const setUnreadDocumentsAction = syncAction('CHAT/SET_UNREAD_DOCUMENTS');
export const setUnreadCompaniesAction = syncAction('CHAT/SET_UNREAD_COMPANIES');
export const setUnreadFromChannelsAction = syncAction('CHAT/SET_UNREAD_FROM_CHANNELS');
// Total-only update from a PubSub CHAT_UNREAD_UPDATE event (closed-drawer). Payload is
// the authoritative workspace total (a number); sets `totalUnreadCount` and MUST NOT
// touch the per-company/document maps (the event has no authoritative values for them).
export const setTotalUnreadFromWsAction = syncAction('CHAT/SET_TOTAL_UNREAD_FROM_WS');
